import api from './index';

class AfterPayReportsService {
  
  constructor() {
    // Usar instância com autenticação automática
    this.api = api;
  }
  
  /**
   * Obter estatísticas principais dos relatórios AfterPay
   * @param {Object} filters - Filtros de data e região
   * @returns {Promise<Object>} Estatísticas principais
   */
  async getMainStats(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.dateFilter) {
        params.append('dateFilter', filters.dateFilter);
      }
      
      if (filters.regionFilter) {
        params.append('regionFilter', filters.regionFilter);
      }
      
      const queryString = params.toString();
      const url = `/api/afterpay-reports/stats${queryString ? `?${queryString}` : ''}`;
      
      console.log('📊 Buscando estatísticas AfterPay:', url);
      
      const response = await this.api.get(url);
      
      if (response.data.success) {
        console.log('✅ Estatísticas obtidas:', response.data.data);
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Erro ao obter estatísticas');
      }
      
    } catch (error) {
      console.error('❌ Erro ao buscar estatísticas AfterPay:', error);
      throw error;
    }
  }
  
  /**
   * Obter dados do mapa do Brasil (vendas por estado)
   * @param {Object} filters - Filtros de data
   * @returns {Promise<Array>} Dados por estado
   */
  async getMapData(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.dateFilter) {
        params.append('dateFilter', filters.dateFilter);
      }
      
      const queryString = params.toString();
      const url = `/api/afterpay-reports/map-data${queryString ? `?${queryString}` : ''}`;
      
      console.log('🗺️ Buscando dados do mapa:', url);
      
      const response = await this.api.get(url);
      
      if (response.data.success) {
        console.log('✅ Dados do mapa obtidos:', response.data.data);
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Erro ao obter dados do mapa');
      }
      
    } catch (error) {
      console.error('❌ Erro ao buscar dados do mapa:', error);
      throw error;
    }
  }
  
  /**
   * Obter evolução mensal de pedidos
   * @returns {Promise<Object>} Dados da evolução mensal
   */
  async getMonthlyEvolution() {
    try {
      console.log('📈 Buscando evolução mensal...');
      
      const response = await this.api.get('/api/afterpay-reports/monthly-evolution');
      
      if (response.data.success) {
        console.log('✅ Evolução mensal obtida:', response.data.data);
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Erro ao obter evolução mensal');
      }
      
    } catch (error) {
      console.error('❌ Erro ao buscar evolução mensal:', error);
      throw error;
    }
  }
  
  /**
   * Obter distribuição de status dos pedidos
   * @param {Object} filters - Filtros de data
   * @returns {Promise<Array>} Status dos pedidos
   */
  async getOrdersStatus(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.dateFilter) {
        params.append('dateFilter', filters.dateFilter);
      }
      
      const queryString = params.toString();
      const url = `/api/afterpay-reports/orders-status${queryString ? `?${queryString}` : ''}`;
      
      console.log('📊 Buscando status dos pedidos:', url);
      
      const response = await this.api.get(url);
      
      if (response.data.success) {
        console.log('✅ Status dos pedidos obtidos:', response.data.data);
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Erro ao obter status dos pedidos');
      }
      
    } catch (error) {
      console.error('❌ Erro ao buscar status dos pedidos:', error);
      throw error;
    }
  }
  
  /**
   * Obter relatório completo para a dashboard
   * @param {Object} filters - Filtros aplicados
   * @returns {Promise<Object>} Relatório completo
   */
  async getCompleteReport(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.dateFilter) {
        params.append('dateFilter', filters.dateFilter);
      }
      
      if (filters.regionFilter) {
        params.append('regionFilter', filters.regionFilter);
      }
      
      const queryString = params.toString();
      const url = `/api/afterpay-reports/complete${queryString ? `?${queryString}` : ''}`;
      
      console.log('📋 Buscando relatório completo:', url);
      
      const response = await this.api.get(url);
      
      if (response.data.success) {
        console.log('✅ Relatório completo obtido:', response.data.data);
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Erro ao obter relatório completo');
      }
      
    } catch (error) {
      console.error('❌ Erro ao buscar relatório completo:', error);
      throw error;
    }
  }
  
  /**
   * Formatar moeda brasileira
   * @param {number} valueInCents - Valor em centavos
   * @returns {string} Valor formatado
   */
  formatCurrency(valueInCents) {
    if (!valueInCents && valueInCents !== 0) return 'R$ 0,00';
    
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valueInCents / 100);
  }
  
  /**
   * Formatar número brasileiro
   * @param {number} value - Valor numérico
   * @returns {string} Número formatado
   */
  formatNumber(value) {
    if (!value && value !== 0) return '0';
    
    return new Intl.NumberFormat('pt-BR').format(value);
  }
}

// Exportar instância única
export default new AfterPayReportsService();